/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import Moment from "moment/moment";
import PropTypes from "prop-types";

export default class AddNoteModal extends React.Component {
    static get propTypes() {
        return {
            newNote: PropTypes.object.isRequired,
            notes: PropTypes.array.isRequired,
            holds: PropTypes.array.isRequired,
            toggleHold: PropTypes.func.isRequired,
            updateNote: PropTypes.func.isRequired
        };
    }

    render() {
        return (
            <div>
                <div className="note-modal-content">
                    <div className="note-content">
                        <strong>Add a note:</strong>
                        <textarea placeholder="Add a note" onChange={(e) => this.props.updateNote(e.target.value)}/>
                    </div>

                    <div className="new-note-holds">
                        <div><strong>Select a hold:</strong></div>
                        <span className= {this.props.newNote.credit? "selected" : "grey-box" }  onClick={() => this.props.toggleHold('credit')} >CREDIT</span>
                        <span className= {this.props.newNote.rights? "selected" : "grey-box" } onClick={() => this.props.toggleHold('rights') }>RIGHTS</span>
                        <span className= {this.props.newNote.cover? "selected" : "grey-box" } onClick={() => this.props.toggleHold('cover') }>COVER</span>
                        <span className= {this.props.newNote.other? "selected" : "grey-box" } onClick={() => this.props.toggleHold('other') }>OTHER</span>
                    </div>
                    <div className="modal-notes">
                        {<div className="notes">
                            {(this.props.notes && this.props.notes.length > 0) ?
                                <div >
                                    {this.props.notes.map((notes) =>
                                        <div className="note addNotesNotes" >
                                            <span className="left-cell"> <b>{Moment.utc(notes.createdTimestamp).local().format("MM-DD-YYYY HH:mm:ss")  + " "} [{notes.userFirstName}] : </b>  </span> <div className="right-cell">{
                                                notes.collectionNoteHolds && notes.collectionNoteHolds.length > 0 && notes.collectionNoteHolds.map((holds) =>{
                                                    return  <span className={(this.props.newNote[holds.hold.toLowerCase()]) ? 'tableBox addNotesNotes orangeBox' : 'tableBox addNotesNotes'} onClick={() => this.props.toggleHold(holds.hold)} >{holds.hold}</span>;
                                                })
                                            } <span id= "note"> {notes.body}  </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                : null}
                        </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsComponents/AddNoteModal.js